<template>
  <v-card flat>
    <data-list :payload="listPayloadObj" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
export default {
  props: ['projectId'],
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: { isactive: true },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        hideSearch: true,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      pagination: !this.$format.isEmptyObject(this.$store.state.common.GENERAL_ACTIVITIES_INDEX) ? this.$store.state.common.GENERAL_ACTIVITIES_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'generalactivities'
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.common.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '35%'
      }, {
        text: this.$t('message.timer.hours'),
        value: 'hours',
        width: '35%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '15%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '15%'
      }]
    },
    ...mapGetters(['formType']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.common.updateActivity') : this.$t('message.common.addActivity'),
        properties: [{
          model: 'name',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.common.name'),
          class: 'xs6'
        }, {
          model: 'hours',
          rules: [],
          type: this.formType.NUMBER,
          class: 'xs6',
          label: this.$t('message.timer.hours')
        }, {
          model: 'isactive',
          rules: [],
          type: this.formType.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.formType.CHECKBOX,
          class: 'xs6 pt-2',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = { type: 'GENERAL_ACTIVITIES_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      this.$api.execute('get', `${this.MODULE}`)
        .then((response) => {
          this.listPayloadObj.headers = this.headers
          this.listPayloadObj.loading = false
          let data = response.data.map((item) => {
            item.hours = this.$format.replaceDotWithComma(item.hours)
            return item
          })
          this.listPayloadObj.list = data
          this.total = response.data.length
        })
    },
    getSingleRecordHandler (id) {
      this.$api.getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then((result) => {
          if (result.data) this.modelObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.modelObj.isactive = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        model.project_id = this.projectId
        let url = this.MODULE
        this.$api.saveUpdateHandler(url, model)
          .then(() => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
